var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "login-container" }, [
      _vm.isLoading
        ? _c("div", { staticClass: "loading" }, [
            _c("div", { staticClass: "spinner" }),
            _vm._v(" "),
            _c("p", [_vm._v("Redirecting to login...")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "error" }, [
            _c("p", [_vm._v(_vm._s(_vm.error))]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.redirectToLogin } }, [
              _vm._v("Try Again")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a66410d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a66410d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/login/index.vue
// module id = 1712
// module chunks = 0